var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"service"}},[_c('div',{staticClass:"secondnav"},[_c('div',{attrs:{"id":"secNavBox"}},[_c('secondnav',{attrs:{"nav":'about'}})],1),_vm._v(" "),_c('div',{attrs:{"id":"secNavNextBox"}})]),_vm._v(" "),_c('div',{staticClass:"views"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae0795d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/about.vue
// module id = null
// module chunks = 